import axios from "axios";
import Vue from "vue"
import {
  gAccount
} from "../data/Account";
import {
  gConfig
} from "../data/Config";
let vm = new Vue()

  /**
   * 监听token过期时间
   * @ return: Boolean
   */
  export const tokenExpressInTime = () => {
    let date = new Date()
    let tokenTime = localStorage.getItem('tokenTime')
    // 当前时间减去获取本地过期时间的值是否大于0   大 于0为过期返回true 否则返回false
    return (date.getTime() - Number(tokenTime)) > 0 ? true : false
  }

axios.interceptors.response.use(res => {
  if (res.data.hasOwnProperty('code') && res.data.code != 0) {
    console.log(res.data.ret)
    if (res.data.ret == 'token值过期') {
      location.href = '/'
    }
    vm.$message({
      message: res.data.ret,
      type: "warning"
    });
    return ;
  }
  return res.data;
})


/*****************************************************************
 *
 */

//获取所有游戏数据
export const protocol_login = (name, password) => {
  return axios({
    url: gConfig.url_shop_server + "ZgrAccount/login" + "?name=" + name + "&password=" + password,
    method: 'GET',
    data: ""
  })
}

//获取所有游戏数据
export const protocol_get_game_list = () => {
  return axios({
    url: gConfig.url_cms_server + "ZgrGame/get_game_all"+ "?token=" + gAccount.get_token(),
    method: 'GET',
    data: ""
  })
}

//获取店铺所有游戏数据
export const protocol_get_shop_game_list = () => {
  return axios({
    url: gConfig.url_cms_server + "ZgrGame/get_game_offine" + "?token=" + gAccount.get_token(),
    method: 'GET',
    data: ""
  })
}
// 旧版
// export const protocol_get_shop_game_list = () => {
//   return axios({
//     url: gConfig.url_shop_server + "ZgrGameOperation/shop_game_list" + "?token=" + gAccount.get_token(),
//     method: 'GET',
//     data: ""
//   })
// }
//获取所有进行中的游戏数据
export const protocol_get_game_playing_list = () => {
  return axios({
    url: gConfig.url_shop_server + "ZgrGameOperation/shop_game_playing_list" + "?token=" + gAccount.get_token(),
    method: 'GET',
    data: ""
  })
}


//开启游戏
export const protocol_game_start = (game_id, remarks,hall_type,max_user_count) => {
  return axios({
    url: gConfig.url_shop_server + "ZgrGameOperation/start_game" + "?token=" + gAccount.get_token() + "&game_id=" +
      game_id + "&remarks=" + remarks+"&hall_type="+hall_type+"&max_user_count="+max_user_count,
    method: 'GET',
    data: ""
  })
}


//结束游戏
export const protocol_game_stop = (id, duration) => {
  return axios({
    url: gConfig.url_shop_server + "ZgrGameOperation/stop_game" + "?token=" + gAccount.get_token() + "&id=" + id +
      "&duration=" + duration,
    method: 'GET',
    data: ""
  })
}
//获取店铺id
export const shop_info = () => {
  return axios({
    url: gConfig.url_shop_server + "ZgrAccount/get_shop_id" + "?token=" + gAccount.get_token(),
    method: 'GET',
    data: ""
  })
}
//获取店铺游戏价格
export const ZgrGameShopget_game_shop = (shop_id) => {
  return axios({
    url: gConfig.url_cms_server + "ZgrGameShop/get_game_shop_offline" + "?token=" + gAccount.get_token()+"&shop_id="+shop_id,
    method: 'GET',
    data: ""
  })
}

//获取所有店铺数据(包括所有的店铺状态)
export const get_shop_data = () => {
  return axios({
    url: gConfig.url_cms_server + "ZgrShop/get_shop_data_all",
    method: 'POST',
    data: ""
  })
}

//创建加入游戏的二维码
export const creat_qrcode_url = (gamesseion_id) => {
  return gConfig.url_account_server + "ZgrWeixinAuth/joingame2?outstr=operation2__" + gamesseion_id;
}

/* 获取本场游戏视频 */
export const get_game_video = (shop_id,hall_type,start_time,end_time) => {
  return axios({
    url: gConfig.url_shop_server + "ZgrMrVideo/get_mrVideoList?shop_id=" + shop_id+ '&hall_type=' + hall_type+ '&start_time=' + start_time+ '&end_time=' + end_time,
    method: 'POST',
    data: ""
  })
}

//上传
export const requestShowuploadfile = (formData,type) => {
  return axios({
    // url: gConfig.url_cms_server + "ZgrFile/upload_test",
    url: gConfig.url_cms_server + "ZgrFile/com_upload?fileName=mrvideo/"+type + "&upload_token=76467818" ,
    method: 'POST',
    data: formData
  })
}

/* 作废游戏场次： */
export const get_cancel_game_session = (game_session_id) => {
  return axios({
    url: gConfig.url_shop_server + "ZgrGameOperation/cancel_gameSession?game_session_id=" + game_session_id+ "&token=" + gAccount.get_token(),
    method: 'POST',
    data: ""
  })
}

/* 修改场次人数：： */
export const get_edit_game_sessionCount = (game_session_id,count) => {
  return axios({
    url: gConfig.url_shop_server + "ZgrGameOperation/edit_gameSessionCount?game_session_id=" + game_session_id+ "&token=" + gAccount.get_token()+"&count="+count,
    method: 'POST',
    data: ""
  })
}

/* 修改时间：： */
export const get_edit_time = (time,game_session_id) => {
  return axios({
    url: gConfig.url_shop_server + "ZgrGameOperation/edit_startTime?game_start_time=" + time+ "&token=" + gAccount.get_token()+"&game_session_id="+game_session_id,
    method: 'POST',
    data: ""
  })
}

/* 获取结束的游戏列表：： */
export const get_shop_game_over_list = (time_start,time_close) => {
  return axios({
    url: gConfig.url_shop_server + "ZgrGameOperation/shop_game_over_list?time_start=" + time_start+
    "&time_close=" + time_close+ "&token=" + gAccount.get_token(),
    method: 'POST',
    data: ""
  })
}

// 添加场次（post）
export const protocol_ZgrShopOstentationOrder_add = (hall_type,time_start,time_end,game_id,play_with_count,aftert_pay_status) => {
  return axios({
    url: gConfig.url_shop_server + "ZgrShopOstentationOrder/ostentation_order_add",
    method: 'POST',
    data: "hall_type=" + hall_type+"&time_start=" + time_start+"&time_end="+time_end+"&game_id="+game_id+ "&token=" + gAccount.get_token()+"&play_with_count="+play_with_count+"&aftert_pay_status="+aftert_pay_status
  })
}

// 添加详细（post）
export const protocol_ZgrShopOstentation_add = (ostentation_order_id,phone,people_count,net_receipts,payment_mode,people_source,remarks,thrid_party_code,turnover,offline_conversion,payment_serial_number,hall_type,extra_money,extra_money_type,waiter) => {
  return axios({
    url: gConfig.url_shop_server + "ZgrShopOstentationOrderDetail/ostentation_detail_add2",
    method: 'POST',
    data: "ostentation_order_id=" + ostentation_order_id+"&phone="+phone+"&token=" + gAccount.get_token()+"&people_count="+people_count+"&net_receipts="+net_receipts+"&payment_mode="+payment_mode+"&people_source="+people_source+"&remarks="+remarks+"&thrid_party_code="+thrid_party_code+"&turnover="+turnover+"&offline_conversion="+offline_conversion+"&payment_serial_number="+payment_serial_number+"&hall_type="+hall_type+"&extra_money="+extra_money+"&extra_money_type="+extra_money_type+"&waiter="+waiter,
  })
}

// hall_type: 1   厅号
// time_start: 1637116980
// time_end: 1637119828
// phone: "13636893703"   手机号
// game_id: 13   游戏id
// people_count: 4    人数

// net_receipts: 138   实收
// payment_mode: "微信"  支付方式
// people_source: "线下路过"   用户来源
// remarks: "备注"    备注
// thrid_party_code: "第三方券码" 第三方券码
// turnover: 158   营业额

//获取历史记录（get）
export const protocol_ZgrShopOstentation_list_history = (time_start,time_end) => {
  return axios({
    url: gConfig.url_shop_server + "ZgrShopOstentationOrder/get_shop_ostentation_record?time_start=" + time_start+
    "&time_end=" + time_end+ "&token=" + gAccount.get_token(),
    method: 'GET',
    data: ""
  })
}
//获取场次（get）
export const protocol_ZgrShopOstentationOrder_list = (time_start,time_end) => {
  return axios({
    url: gConfig.url_shop_server + "ZgrShopOstentationOrder/get_shop_ostentation_order?time_start=" + time_start+
    "&time_end=" + time_end+ "&token=" + gAccount.get_token(),
    method: 'GET',
    data: ""
  })
}
//获取详细（get）
export const protocol_ZgrShopOstentation_list = (time_start,time_end) => {
  return axios({
    url: gConfig.url_shop_server + "ZgrShopOstentationOrderDetail/get_shop_ostentation_detail?time_start=" + time_start+
    "&time_end=" + time_end+ "&token=" + gAccount.get_token(),
    method: 'GET',
    data: ""
  })
}

// 修改场次（post）
export const protocol_ZgrShopOstentationOrder_eidt = (hall_type,time_start,time_end,game_id,id,play_with_count,aftert_pay_status) => {
  return axios({
    url: gConfig.url_shop_server + "ZgrShopOstentationOrder/eidt",
    method: 'POST',
    data: "hall_type=" + hall_type+"&time_start=" + time_start+"&time_end="+time_end+"&game_id="+game_id+"&id="+id+ "&token=" + gAccount.get_token()+"&play_with_count="+play_with_count+"&aftert_pay_status="+aftert_pay_status
  })
}
// 修改详细（post）
export const protocol_ZgrShopOstentation_eidt = (ostentation_detail_id,phone,people_count,net_receipts,payment_mode,people_source,remarks,thrid_party_code,turnover,offline_conversion,payment_serial_number,hall_type,extra_money,extra_money_type,waiter,private_domain) => {
  return axios({
    url: gConfig.url_shop_server + "ZgrShopOstentationOrderDetail/eidt2",
    method: 'POST',
    data: "ostentation_detail_id=" + ostentation_detail_id+"&phone="+phone+"&token=" + gAccount.get_token()+"&people_count="+people_count+"&net_receipts="+net_receipts+"&payment_mode="+payment_mode+"&people_source="+people_source+"&remarks="+remarks+"&thrid_party_code="+thrid_party_code+"&turnover="+turnover+"&offline_conversion="+offline_conversion+"&payment_serial_number="+payment_serial_number.trim()+"&hall_type="+hall_type+"&extra_money="+extra_money+"&extra_money_type="+extra_money_type+"&waiter="+waiter+"&private_domain="+private_domain
  })
}
// // 删除场次（post）
// export const protocol_ZgrShopOstentationOrder_delete = (id) => {
//   return axios({
//     url: gConfig.url_shop_server + "ZgrShopOstentationOrder/delete",
//     method: 'POST',
//     data: "id="+id+ "&token=" + gAccount.get_token()
//   })
// }
// 删除场次（post）
export const protocol_ZgrShopOstentationOrder_delete = (id) => {
  return axios({
    url: gConfig.url_shop_server + "ZgrShopMiniprogramOrders/ostentation_delete",
    method: 'POST',
    data: "id="+id+ "&token=" + gAccount.get_token()
  })
}
// 删除详细（post）
export const protocol_ZgrShopOstentation_delete = (id) => {
  return axios({
    //url: gConfig.url_shop_server + "ZgrShopOstentationOrderDetail/delete",
    url: gConfig.url_shop_server + "ZgrShopMiniprogramOrders/delete",
    method: 'POST',
    data: "ostentation_detail_id="+id+ "&token=" + gAccount.get_token()
  })
}

// 查询有没有用户须知（post）
export const protocol_ZgrShopOstentation_select_signature_status = (id) => {
  return axios({
    url: gConfig.url_shop_server + "ZgrShopOstentationOrderDetail/select_signature_status",
    method: 'POST',
    data: "ostentation_detail_id="+id+ "&token=" + gAccount.get_token()
  })
}
// 查询有没有注册（post）
export const protocol_ZgrShopOstentation_send_register = (id) => {
  return axios({
    url: gConfig.url_shop_server + "ZgrShopOstentationOrderDetail/check_registered",
    method: 'POST',
    data: "ostentation_detail_id="+id+ "&token=" + gAccount.get_token()
  })
}
// 发送和短信（post）
export const protocol_ZgrShopOstentation_send_sms = (id) => {
  return axios({
    url: gConfig.url_shop_server + "ZgrShopOstentationOrderDetail/send_sms",
    method: 'POST',
    data: "ostentation_detail_id="+id+ "&token=" + gAccount.get_token()
  })
}
// 开始订单（post）
export const protocol_ZgrShopStart_game = (id,hall_type) => {
  return axios({
    url: gConfig.url_shop_server + "ZgrShopOstentationOrder/start_order",
    method: 'POST',
    data: "id="+id+ "&hall_type=" + hall_type+ "&token=" + gAccount.get_token()
  })
}
// 结束订单（post）
export const protocol_ZgrShopEnd_game = (id,hall_type,abnormal_count,abnormal_remarkes) => {
  return axios({
    url: gConfig.url_shop_server + "ZgrShopOstentationOrder/finish_order",
    method: 'POST',
    data: "id="+id+ "&hall_type=" + hall_type+ "&abnormal_count=" + abnormal_count+ "&abnormal_remarkes=" + abnormal_remarkes+ "&token=" + gAccount.get_token()
  })
}
// 退款订单（post）
export const protocol_ZgrShopEnd_game_abnormal = (id,order_refund_number,order_refund_remarkes) => {
  return axios({
    url: gConfig.url_shop_server + "ZgrShopOstentationOrderRefund/add",
    method: 'POST',
    data: "ostentation_detail_id="+id+ "&order_refund_number=" + order_refund_number+ "&order_refund_remarkes=" + order_refund_remarkes+ "&token=" + gAccount.get_token()
  })
}



//前厅小游戏查询
export const protocol_ZgrShopOstentation_Lobbygames_list = (time_start,time_end) => {
  return axios({
    url: gConfig.url_shop_server + "ZgrShopGoodsSell/get?time_start=" + time_start+
    "&time_end=" + time_end+ "&token=" + gAccount.get_token(),
    method: 'GET',
    data: ""
  })
}
//前厅小游戏增加
export const protocol_ZgrShopOstentationOrder_Lobbygames_add = (phone,time_start,time_end,goods_name,net_receipts,payment_serial_number) => {
  return axios({
    url: gConfig.url_shop_server + "ZgrShopGoodsSell/add",
    method: 'POST',
    data: "phone=" + phone+"&time_start=" + time_start+"&time_end="+time_end+"&goods_name="+goods_name+ "&token=" + gAccount.get_token()+"&net_receipts="+net_receipts+"&payment_serial_number="+payment_serial_number.trim()
  })
}
//前厅小游戏修改
export const protocol_ZgrShopOstentationOrder_Lobbygames_eidt = (phone,time_start,time_end,goods_name,id,net_receipts,payment_serial_number) => {
  return axios({
    url: gConfig.url_shop_server + "ZgrShopGoodsSell/eidt",
    method: 'POST',
    data: "phone=" + phone+ "&time_start=" + time_start+"&time_end="+time_end+"&goods_name="+goods_name+"&id="+id+ "&token=" + gAccount.get_token()+"&net_receipts="+net_receipts+"&payment_serial_number="+payment_serial_number.trim()
  })
}
//前厅小游戏删除
export const protocol_ZgrShopOstentationOrder_Lobbygames_delete = (id) => {
  return axios({
    url: gConfig.url_shop_server + "ZgrShopGoodsSell/delete",
    method: 'POST',
    data: "id="+id+ "&token=" + gAccount.get_token()
  })
}


//会员卡销售查询time_start
export const protocol_ZgrShopOstentation_Membership_list = (time_start,time_end) => {
  return axios({
    url: gConfig.url_shop_server + "ZgrShopUserStored/get?time_start=" + time_start+
    "&time_end=" + time_end+ "&token=" + gAccount.get_token(),
    method: 'GET',
    data: ""
  })
}
//会员卡销售增加
export const protocol_ZgrShopOstentationOrder_Membership_add = (time,member_id,member_name,phone,recharge_money,give_money,card_holder) => {
  return axios({
    url: gConfig.url_shop_server + "ZgrShopUserStored/add",
    method: 'POST',
    data: "time=" + time+ "&member_id=" + member_id+"&member_name="+member_name+"&phone="+phone+ "&token=" + gAccount.get_token()+"&recharge_money="+recharge_money+"&give_money="+give_money+"&card_holder="+card_holder
  })
}
//会员卡销售修改
export const protocol_ZgrShopOstentationOrder_Membership_eidt = (time,member_id,member_name,phone,recharge_money,give_money,card_holder,id) => {
  return axios({
    url: gConfig.url_shop_server + "ZgrShopUserStored/eidt",
    method: 'POST',
    data: "time=" + time+ "&member_id=" + member_id+"&member_name="+member_name+"&phone="+phone+ "&token=" + gAccount.get_token()+"&recharge_money="+recharge_money+"&give_money="+give_money+"&card_holder="+card_holder+"&id="+id
  })
}
//会员卡销售删除
export const protocol_ZgrShopOstentationOrder_Membership_delete = (id) => {
  return axios({
    url: gConfig.url_shop_server + "ZgrShopUserStored/delete",
    method: 'POST',
    data: "id="+id+ "&token=" + gAccount.get_token()
  })
}

//门店统计用户方式time_start
export const protocol_ZgrShopOstentationOrderDetail_shop_simple_statistics = (time_start,time_end) => {
  return axios({
    url: gConfig.url_shop_server + "ZgrShopOstentationOrderDetail/shop_simple_statistics?time_start=" + time_start+
    "&time_end=" + time_end+ "&token=" + gAccount.get_token(),
    method: 'GET',
    data: ""
  })
}
//门店业绩相关接口（简易）
//接口位置 门店服务器
//获取设置的业绩
export const protocol_ZgrShopAchievement_achievement_get = () => {
  return axios({
    url: gConfig.url_shop_server + "ZgrShopAchievement/achievement_get?token=" + gAccount.get_token(),
    method: 'GET',
    data: ""
  })
}
//设置业绩
export const protocol_ZgrShopAchievement_achievement_set = (achievement_data) => {
  return axios({
    url: gConfig.url_shop_server + "ZgrShopAchievement/achievement_set",
    method: 'POST',
    data: "achievement_data=" + achievement_data+ "&token=" + gAccount.get_token()
  })
}



//门店审核修改接口
//获取场次（get）
export const protocol_ZgrShopOstentationOrder_list1 = (time_start,time_end) => {
  return axios({
    url: gConfig.url_shop_server + "ZgrShopOstentationAudit/getShopNoPastOrder?time_start=" + time_start+
    "&time_end=" + time_end+ "&token=" + gAccount.get_token(),
    method: 'GET',
    data: ""
  })
}
//获取详细（get）
export const protocol_ZgrShopOstentation_list1 = (time_start,time_end) => {
  return axios({
    url: gConfig.url_shop_server + "ZgrShopOstentationAudit/getShopNoPastDetail?time_start=" + time_start+
    "&time_end=" + time_end+ "&token=" + gAccount.get_token(),
    method: 'GET',
    data: ""
  })
}
// 修改场次（post）
export const protocol_ZgrShopOstentationOrder_eidt1 = (hall_type,time_start,time_end,game_id,id,play_with_count,aftert_pay_status) => {
  return axios({
    url: gConfig.url_shop_server + "ZgrShopOstentationAudit/editShopNoPastOrder",
    method: 'POST',
    data: "hall_type=" + hall_type+"&time_start=" + time_start+"&time_end="+time_end+"&game_id="+game_id+"&id="+id+ "&token=" + gAccount.get_token()+"&play_with_count="+play_with_count+"&aftert_pay_status="+aftert_pay_status
  })
}
// 修改详细（问题修改页使用）（post）
export const protocol_ZgrShopOstentation_eidt1 = (ostentation_detail_id,phone,people_count,net_receipts,payment_mode,people_source,remarks,thrid_party_code,turnover,offline_conversion,payment_serial_number,hall_type,extra_money,extra_money_type) => {
  return axios({
    url: gConfig.url_shop_server + "ZgrShopOstentationAudit/editShopNoPastDetail",
    method: 'POST',
    data: "ostentation_detail_id=" + ostentation_detail_id+"&phone="+phone+"&token=" + gAccount.get_token()+"&people_count="+people_count+"&net_receipts="+net_receipts+"&payment_mode="+payment_mode+"&people_source="+people_source+"&remarks="+remarks+"&thrid_party_code="+thrid_party_code+"&turnover="+turnover+"&offline_conversion="+offline_conversion+"&payment_serial_number="+payment_serial_number+"&hall_type="+hall_type+"&extra_money="+extra_money+"&extra_money_type="+extra_money_type
  })
}

//确认修改完成
export const protocol_confirm_preservation = () => {
  return axios({
    url: gConfig.url_shop_server + "ZgrShopOstentationAudit/shopStoreConfirmationEdit",
    method: 'POST',
    data: "token=" + gAccount.get_token()
  })
}


//获取游戏版本
export const protocol_get_game_version = () => {
  return axios({
    url: gConfig.url_cms_server + "ZgrShopLocalProjectVersion/get_shop_game_version",
    method:'POST',
    data:"token=" + gAccount.get_token(),
  })
}


export const protocol_data_ShopWaiter_get = () => {
  return axios({
    url: gConfig.url_shop_server + "ZgrShopWaiter/get",
    method:'POST',
    data:"token=" + gAccount.get_token()
  })
}
 export const protocol_data_ShopWaiter_add = (shop_waiter) => {
  return axios({
    url: gConfig.url_shop_server + "ZgrShopWaiter/add",
    method:'POST',
    data:"token=" + gAccount.get_token()+"&shop_waiter=" + shop_waiter,
  })
}
 export const protocol_data_ShopWaiter_edit = (id,shop_waiter) => {
  return axios({
    url: gConfig.url_shop_server + "ZgrShopWaiter/eidt",
    method:'POST',
    data:"token=" + gAccount.get_token()+"&id=" + id+"&shop_waiter=" + shop_waiter.trim(),
  })
}
  export const protocol_data_ShopWaiter_delete = (id) => {
   return axios({
     url: gConfig.url_shop_server + "ZgrShopWaiter/delete",
     method:'POST',
     data:"token=" + gAccount.get_token()+"&id=" + id,
   })
}



//获取待排场的记录
export const protocol_ZgrShopOstentation_PaiChangWaiting = (time_start,time_end) => {
  return axios({
    url: gConfig.url_shop_server + "ZgrShopMiniprogramOrders/get?token=" + gAccount.get_token()+"&time_start=" + time_start+"&time_end="+time_end,
    method: 'GET',
    data: ""
  })
}
// 小程序订单新建排场（post）
export const protocol_ZgrMiniprogramOrders_add = (hall_type,time_start,time_end,game_id,play_with_count,aftert_pay_status,id) => {
  return axios({
    url: gConfig.url_shop_server + "ZgrShopMiniprogramOrders/ostentation_order_add",
    method: 'POST',
    data: "hall_type=" + hall_type+"&time_start=" + time_start+"&time_end="+time_end+"&game_id="+game_id+ "&token=" + gAccount.get_token()+"&play_with_count="+play_with_count+"&aftert_pay_status="+aftert_pay_status+"&id="+id
  })
}

// 小程序订单获取要加入的排场
export const protocol_ZgrMiniprogramOrders_ostentation = () => {
  return axios({
    url: gConfig.url_shop_server + "ZgrShopMiniprogramOrders/get_shop_ostentation",
    method: 'POST',
    data: "token=" + gAccount.get_token()
  })
}
// 小程序订单加入排场
export const protocol_ZgrMiniprogramOrders_miniProgramOrder_add = (hall_type,id,ostentation_order_id) => {
  return axios({
    url: gConfig.url_shop_server + "ZgrShopMiniprogramOrders/miniProgramOrder_add",
    method: 'POST',
    data: "token=" + gAccount.get_token()+"&hall_type=" + hall_type+"&id=" + id+"&ostentation_order_id="+ostentation_order_id
  })
}

//生成日报
export const protocol_dailyPaper = () => {
  return axios({
    url: gConfig.url_shop_server + "ZgrShopOstentationOrderDetailDailyPaper/shop_simple_statistics",
    method: 'POST',
    data: "token=" + gAccount.get_token()
  })
}

//获取小程序跳转链接
export const protocol_miniJump = () => {
  return axios({
    url: gConfig.url_shop_server + "ZgrShopMiniprogramJump/miniprogram_jump",
    method: 'POST',
    data: "token=" + gAccount.get_token()
  })
}



// WEBPACK FOOTER //
// ./src/assets/js/network/request.js